import { SOURCE_FORMAT_LABEL, type SourceFormat } from "@models/circuit-ir";
import { Chip, Tooltip } from "@mui/material";

interface SourceFormatChipProps {
  /** `SchematicVersion.source_format` — typed but accepts any string for
   *  forward-compat with adapters added on the backend after this PR. */
  format: string | null | undefined;
}

/**
 * Small badge that surfaces which adapter ingested a `:SchematicVersion`
 * (kicad_sch / kicad_net / easyeda / altium_net / edif / eagle / librepcb /
 * ltspice / spice / agent / manual / legacy_neo4j).
 *
 * Per IR plan §3.2 — different adapters have different round-trip
 * fidelity; surfacing the source helps the user know what to expect on
 * re-export.
 */
export function SourceFormatChip({ format }: SourceFormatChipProps) {
  if (!format) return null;
  const label =
    SOURCE_FORMAT_LABEL[format as SourceFormat] ?? format.replace(/_/g, " ");
  return (
    <Tooltip title={`Imported from ${label}`}>
      <Chip
        size="small"
        label={label}
        variant="outlined"
        sx={{ fontSize: 10, height: 18 }}
      />
    </Tooltip>
  );
}
